import { ModalProps } from '@/types/shared'
import { formatPGDate } from '@/utils/function'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Button, Dialog, FormItem } from 'vnetwork-ui'

interface ProbationDateModalProps extends ModalProps {
    employee_id: number
    employee_name?: string
    onConfirm: (data: { employee_id: number; probation_date: string }) => void
}

interface FormValues {
    probation_date: string
}

const ProbationDateModal: React.FC<ProbationDateModalProps> = ({
    open,
    onClose,
    employee_id,
    employee_name,
    onConfirm,
}) => {
    const { t } = useTranslation()

    const { control, handleSubmit, watch } = useForm<FormValues>({
        defaultValues: {
            probation_date: '',
        },
    })

    const probationDate = watch('probation_date')

    const onSubmit = (data: FormValues) => {
        if (data.probation_date) {
            onConfirm({
                employee_id,
                probation_date: formatPGDate(data.probation_date) as string,
            })
            onClose()
        }
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            title={t('update_probation_date')}
            maxWidth="sm"
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="p-4 space-y-4">
                    <div className="text-sm text-gray-600 mb-4">
                        {employee_name
                            ? `${t('probation_date_warning_with_name', { name: employee_name })}`
                            : t('probation_date_warning')}
                    </div>

                    <FormItem
                        control={control}
                        name="probation_date"
                        type="datepicker"
                        label={t('probation_date')}
                        placeholder={t('select_probation_date')}
                    />

                    <div className="flex justify-end gap-3 pt-4 border-t">
                        <Button
                            variant="outlined"
                            onClick={onClose}
                            type="button"
                        >
                            {t('cancel')}
                        </Button>

                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            disabled={!probationDate}
                        >
                            {t('update_probation_date')}
                        </Button>
                    </div>
                </div>
            </form>
        </Dialog>
    )
}

export default ProbationDateModal
